import { type FC } from 'react';
import { AdUnit } from './AdUnit';
import { type AdSizes } from '../types';
import { type OnAbsentAd } from '../hooks/useAbsentAdHandler';

import dibsCss from 'dibs-css';
import classNames from 'classnames';

type Props = {
    adId: string;
    elementId: string;
    width?: number;
    height?: number;
    lazyLoad?: boolean;
    sizes?: AdSizes;
    heightHold?: number;
    widthHold?: number;
    shouldCollapseOnNoFill?: boolean;
    className?: string;
    onAbsentAd?: OnAbsentAd;
};

export const BillboardBannerAd: FC<Props> = ({
    adId,
    elementId,
    width = 320,
    height = 82,
    lazyLoad = false,
    sizes,
    heightHold,
    widthHold,
    className,
    shouldCollapseOnNoFill = true,
    onAbsentAd,
}) => {
    return (
        <AdUnit
            adId={adId}
            elementId={elementId}
            width={width}
            height={height}
            lazyLoad={lazyLoad}
            sizes={sizes}
            heightHold={heightHold}
            widthHold={widthHold}
            className={classNames(
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.justifyCenter,
                className
            )}
            shouldCollapseOnNoFill={shouldCollapseOnNoFill}
            onAbsentAd={onAbsentAd}
            dataTn="billboard-banner-ad"
        />
    );
};
